module.exports = __webpack_public_path__ + "img/capa2.0c93a6a3.webp";